import { render, staticRenderFns } from "./WorkRecordDetail.vue?vue&type=template&id=44dd72b0&"
import script from "./WorkRecordDetail.vue?vue&type=script&lang=js&"
export * from "./WorkRecordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports